const BLOCKING_BILLING_STATUSES = new Set([
    "expired",
    "past_due",
    "overdue",
    "cancelled",
    "canceled",
    "unpaid",
    "payment_required",
]);

const TRIAL_BILLING_STATUSES = new Set([
    "trial",
    "trial_started",
    "trial_active",
    "trialing",
]);

const normalizeBillingStatus = (status) => String(status || "").trim().toLowerCase();

const isIsoDate = (dateString) => typeof dateString === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateString);

export const getTodayISO = () => new Date().toLocaleDateString("en-CA");

export const formatIsoDatePtBr = (dateString) => {
    if (!isIsoDate(dateString)) return null;
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
};

export const evaluateTenantLifecycle = (tenantData = {}, options = {}) => {
    const todayISO = options.todayISO || getTodayISO();
    const billingStatus = normalizeBillingStatus(tenantData.billingStatus);
    const trialStartDate = tenantData.trialStartDate || null;
    const trialEndsAt = tenantData.trialEndsAt || null;
    const isTrialStatus = TRIAL_BILLING_STATUSES.has(billingStatus);
    const isTrialNotStarted = isIsoDate(trialStartDate)
        && trialStartDate > todayISO
        && isTrialStatus;
    const isTrialExpired = isIsoDate(trialEndsAt)
        && trialEndsAt < todayISO
        && (
            isTrialStatus
            || billingStatus === ""
            || billingStatus === "active"
        );

    if (isTrialNotStarted) {
        return {
            blocked: true,
            reasonCode: "trial_not_started",
            billingStatus: billingStatus || "trial_started",
            trialStartDate,
            trialEndsAt,
            message: formatIsoDatePtBr(trialStartDate)
                ? `Seu periodo de teste começa em ${formatIsoDatePtBr(trialStartDate)}. O acesso sera liberado automaticamente nesta data.`
                : "Seu periodo de teste ainda nao começou. O acesso sera liberado automaticamente na data configurada.",
        };
    }

    if (isTrialExpired) {
        return {
            blocked: true,
            reasonCode: "trial_expired",
            billingStatus: "expired",
            trialStartDate,
            trialEndsAt,
            message: formatIsoDatePtBr(trialEndsAt)
                ? `Seu periodo de teste expirou em ${formatIsoDatePtBr(trialEndsAt)}. Regularize a assinatura para continuar usando o NeoApp.`
                : "Seu periodo de teste expirou. Regularize a assinatura para continuar usando o NeoApp.",
        };
    }

    if (BLOCKING_BILLING_STATUSES.has(billingStatus)) {
        return {
            blocked: true,
            reasonCode: billingStatus === "expired"
                ? "billing_expired"
                : billingStatus === "cancelled" || billingStatus === "canceled"
                    ? "billing_cancelled"
                    : "billing_overdue",
            billingStatus,
            trialStartDate,
            trialEndsAt,
            message: billingStatus === "expired"
                ? "Sua assinatura expirou. Regularize o pagamento para voltar a acessar a plataforma."
                : billingStatus === "cancelled" || billingStatus === "canceled"
                    ? "Sua assinatura foi cancelada. Regularize a conta para voltar a acessar a plataforma."
                    : "Existe uma pendencia financeira na sua assinatura. Regularize o pagamento para continuar usando a plataforma.",
        };
    }

    if (tenantData.active === false) {
        return {
            blocked: true,
            reasonCode: "tenant_inactive",
            billingStatus: billingStatus || "inactive",
            trialStartDate,
            trialEndsAt,
            message: "Esta conta esta inativa ou com assinatura pendente. Reative sua conta para continuar.",
        };
    }

    return {
        blocked: false,
        reasonCode: null,
        billingStatus: billingStatus || null,
        trialStartDate,
        trialEndsAt,
        message: null,
    };
};
